export const CHILD_SIZES = ['4', '6', '8', '10', '12', '14', '16', '18'];
export const ADULT_SIZES = ['24', '26', '28', '30', '32', '34', '36'];
export const ONE_SIZE = ['OneSize'];
export const STANDARD_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

export const MAX_CHILD_SIZE = 20;
export const MIN_ADULT_SIZE = 20;

export const TOUCHABLE_ACTIVE_OPACITY = 0.7;

export const WORD_SIZE_MAP: Record<string, string> = {
  '2xs': 'XXS',
  'extra small': 'XS',
  'extra-small': 'XS',
  extrasmall: 'XS',
  'x-small': 'XS',
  xsmall: 'XS',
  small: 'S',
  medium: 'M',
  large: 'L',
  'extra large': 'XL',
  'extra-large': 'XL',
  extralarge: 'XL',
  'x-large': 'XL',
  xlarge: 'XL',
  'double extra large': 'XXL',
  'double-extra-large': 'XXL',
  doubleextralarge: 'XXL',
  'xx-large': 'XXL',
  xxlarge: 'XXL',
  '2xl': 'XXL',
  '2x-large': 'XXL',
  'triple extra large': 'XXXL',
  'triple-extra-large': 'XXXL',
  '3xl': 'XXXL',
  '3x-large': 'XXXL',
};
